import React, { useEffect } from "react";
import closeSmallTokens from "@amzn/meridian-tokens/base/icon/close-small";
import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import Icon from "@amzn/meridian/icon";
import Responsive from "@amzn/meridian/responsive";
import Row from "@amzn/meridian/row";
import Sheet from "@amzn/meridian/sheet";
import { ISheetsProps } from "./definitions";
import { useSheets } from "./hooks";

import styles from "./style.module.scss";
import { useFilterSheets } from "../filter-sheets/hooks";
import { useEditingDocument } from "../../components/edit-document-modal/hooks";

export const Sheets: React.FC<ISheetsProps> = () => {
    const { isFilterSheetsOpen } = useFilterSheets();
    const { sheets, setOpenSheets, getCurrentStack, closeSheetFromStack } = useSheets();
    const { setIsEditSheetOpen } = useEditingDocument();

    useEffect(() => {
        if (!sheets.children && getCurrentStack().length === 0) {
            setOpenSheets(false);
        }
    }, [sheets.children, getCurrentStack()]);

    return (
        <Responsive
            query="max-width"
            props={{
                filterSheetsWidth: {
                    default: 400,
                    "799px": 228,
                    "975px": 400,
                    "992px": 283,
                    "1280px": 342,
                    "1600px": 457,
                },
                editSheetsWidth: {
                    default: "100%",
                },
            }}
        >
            {({ filterSheetsWidth, editSheetsWidth }) => (
                <>
                    {/* Legacy Sheet */}
                    {sheets.children && (
                        <Sheet
                            className={!isFilterSheetsOpen && styles.sheets}
                            type={isFilterSheetsOpen ? "push" : "overlay"}
                            side="end"
                            open={sheets.isSheetsOpen}
                            onClose={() => {
                                setOpenSheets(false);
                                setIsEditSheetOpen(false);
                            }}
                        >
                            <Column spacing="100" width={"100%"} height={"fill"}>
                                <Row alignmentHorizontal="end">
                                    <Button
                                        onClick={() => {
                                            setOpenSheets(false);
                                            setIsEditSheetOpen(false);
                                        }}
                                        type="icon"
                                    >
                                        <Icon tokens={closeSmallTokens}>Close sheet</Icon>
                                    </Button>
                                </Row>
                            </Column>
                            <Column
                                alignmentHorizontal={"start"}
                                width={isFilterSheetsOpen ? filterSheetsWidth : editSheetsWidth}
                                minWidth={"10%"}
                                maxWidth={sheets.sheetWidth}
                                height={"100%"}
                            >
                                {sheets.children}
                            </Column>
                        </Sheet>
                    )}

                    {getCurrentStack().map((stackedSheet, index) => (
                        <Sheet
                            key={stackedSheet.id || index}
                            className={!isFilterSheetsOpen && styles.sheets}
                            type="overlay"
                            side="end"
                            open={sheets.isSheetsOpen}
                            onClose={() => {
                                if (stackedSheet.id) {
                                    // Get current stack
                                    const currentStack = getCurrentStack();
                                    // Close all sheets with the same ID
                                    currentStack
                                        .filter(sheet => sheet.id === stackedSheet.id)
                                        .forEach(sheet => closeSheetFromStack(sheet.id));
                                }
                            }}
                        >
                            <Column alignmentHorizontal={"start"} width="100%" height={"100%"}>
                                {stackedSheet.content}
                            </Column>
                        </Sheet>
                    ))}
                </>
            )}
        </Responsive>
    );
};
